
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AIAssistantSettings } from "./AIAssistantSettings";
import { APISettings } from "./APISettings";
import { Microsoft365Settings } from "./Microsoft365Settings";
import { AdminTab } from "./AdminTab";
import { ChangelogTab } from "./changelog/ChangelogTab";
import { EnvironmentDebugTab } from "./EnvironmentDebugTab";
import { UnifiedAboutTab } from "./UnifiedAboutTab";
import { ImportExportTabs } from "@/components/data-import-export/ImportExportTabs";
import { useIsAdmin } from "@/hooks/useIsAdmin";
import { useIsDeveloper } from "@/hooks/useIsDeveloper";
import { useState } from "react";

export function SettingsTabs() {
  const { data: isAdmin } = useIsAdmin();
  const { data: isDeveloper } = useIsDeveloper();
  const [activeImportExportTab, setActiveImportExportTab] = useState<"import" | "export">("import");

  return (
    <Tabs defaultValue="ai" className="w-full">
      <TabsList className="grid w-full grid-cols-8">
        <TabsTrigger value="ai">AI Assistant</TabsTrigger>
        <TabsTrigger value="api">API Keys</TabsTrigger>
        <TabsTrigger value="microsoft365">Microsoft 365</TabsTrigger>
        <TabsTrigger value="import-export">Import/Export</TabsTrigger>
        <TabsTrigger value="changelog">Changelog</TabsTrigger>
        <TabsTrigger value="about">About</TabsTrigger>
        {isDeveloper && <TabsTrigger value="debug">Environment</TabsTrigger>}
        {isAdmin && <TabsTrigger value="admin">Admin</TabsTrigger>}
      </TabsList>
      
      <TabsContent value="ai" className="mt-6">
        <AIAssistantSettings />
      </TabsContent>
      
      <TabsContent value="api" className="mt-6">
        <APISettings />
      </TabsContent>
      
      <TabsContent value="microsoft365" className="mt-6">
        <Microsoft365Settings />
      </TabsContent>

      <TabsContent value="import-export" className="mt-6">
        <div className="space-y-6">
          <div>
            <h2 className="text-2xl font-bold">Import/Export Data</h2>
            <p className="text-muted-foreground mt-2">
              Import or export your candidates and clients data using CSV files.
            </p>
          </div>
          
          <Tabs value={activeImportExportTab} onValueChange={(value) => setActiveImportExportTab(value as "import" | "export")} className="w-full">
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="import">Import Data</TabsTrigger>
              <TabsTrigger value="export">Export Data</TabsTrigger>
            </TabsList>
            
            <TabsContent value="import" className="mt-6">
              <ImportExportTabs activeTab="import" />
            </TabsContent>
            
            <TabsContent value="export" className="mt-6">
              <ImportExportTabs activeTab="export" />
            </TabsContent>
          </Tabs>
        </div>
      </TabsContent>

      <TabsContent value="changelog" className="mt-6">
        <ChangelogTab />
      </TabsContent>

      <TabsContent value="about" className="mt-6">
        <UnifiedAboutTab />
      </TabsContent>

      {isDeveloper && (
        <TabsContent value="debug" className="mt-6">
          <EnvironmentDebugTab />
        </TabsContent>
      )}
      
      {isAdmin && (
        <TabsContent value="admin" className="mt-6">
          <AdminTab />
        </TabsContent>
      )}
    </Tabs>
  );
}
